import React, { useEffect } from "react";
import { route } from "../../router/route";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ManagerApi from "../../api/manager.api";
import { toast } from "react-toastify";
import { errorHandler } from "../../util/errorHandler";

function LoginProcess() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const autoLoginFunc = async () => {
    try {
      const response = (await ManagerApi.getMyInfo()).data.data.content;
      sessionStorage.setItem("approval", response.approval);
      sessionStorage.setItem("id", response.id);
      sessionStorage.setItem("name", response.name);
      sessionStorage.setItem("accessMenu", response.accessMenu);
      sessionStorage.setItem("role", response.rootFlag ? "ROOT" : "ADMIN");
      sessionStorage.setItem("email", response.email);
    } catch (error) {
      if (error.response.status === 401) {
        return toast(`${error.response.data.message}`);
      }
      if (error.response.status === 404) {
        return toast(`존재하지 않는 회원입니다.`);
      }
      errorHandler(error);
    }
  };

  useEffect(() => {
    const allRefresh = searchParams.get("refresh");
    if (
      !allRefresh &&
      window.location.pathname !== "/" &&
      window.location.pathname !== route.login
    ) {
      autoLoginFunc();
    }
  }, []);

  return null;
}

export default LoginProcess;
